import React from 'react'
import { approveVideoInterview, deleteVideoInterview, getPendingVideoInterviews } from '../../../../../../common/_services/admin.service'
import { UserVideoInterview } from '../../../../../../common/types/user'

import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { Button } from 'primereact/button'
import { useFetchV2 } from '../../../../_core/hooks'
import Await from '../../../../_core/components/await'

const VideoInterviewReview = () => {
  const [videos,reload] = useFetchV2<UserVideoInterview[],undefined>(async () => (await getPendingVideoInterviews()).data,undefined,[])
  return (
    <Await dependency={videos}>{(videos) =>
      <div className="p-3">
          <DataTable value={videos}>
            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
            <Column
              field="photo"
              header="Video"
              style={{ width: '200px' }}
              body={(y:UserVideoInterview,_) =>  <video className="user-video" src={y.url} controls></video>}>
            </Column>
            <Column field="id"
              header="Action"
              body={(y,_) =>
                <>
                  <Button label="Deny" className="btn btn-secondary" onClick={() => deleteVideoInterview(y.id,reload)}/>
                  <Button label="Approve" className="btn btn-primary mx-2" onClick={() => approveVideoInterview(y.id,reload)}/>
                </>
              }>
            </Column>
          </DataTable>
      </div>
    }</Await>
  )
}



export default VideoInterviewReview
